import {RowAction} from "@beeldit/core/enums/RowAction.enum";
import {FinalTableConfig} from "@beeldit/core/models/FinalTableConfig.interface";
import {PencilSimple} from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
    index: null,
    actions: [],
    rowActions: [
        {
            name: RowAction.EDIT,
            label: 'edit',
            icon: <PencilSimple size={20}/>,
            allowed: true,
            show: true,
            action: (element: any) => {
                console.log('edit', element);
            }
        }
    ],
    rowConfiguration: {
        class: (element: any) => {
            return null;
        }
    },
    columns: [
        {
            name: 'id',
            label: '#',
            key: 'id',
            type: 'number',
            show: true,
            sortable: true,
        },
        {
            name: 'attributes',
            label: 'combination_main_attribute',
            key: 'attributes',
            attribute: 'pivot.value',
            type: 'array-first-element',
            show: true,
            sortable: false,
        },
        {
            name: 'name',
            label: 'name',
            key: 'name.es',
            type: 'string',
            show: true,
            sortable: true,
        },
        {
            name: 'stock',
            label: 'stock',
            key: 'stock',
            type: 'number',
            show: true,
            sortable: true,
        },
        {
            name: 'price',
            label: 'price',
            key: 'price',
            type: 'currency',
            currency: 'EUR',
            show: true,
            sortable: true,
        },
        {
            name: 'tax',
            label: 'tax',
            key: 'tax',
            type: 'currency',
            currency: 'EUR',
            show: true,
            sortable: true,
        },
        {
            name: 'sku',
            label: 'sku',
            key: 'sku',
            type: 'string',
            show: true,
            sortable: true,
        },
    ],
    pagination: {
        enabled: true,
        back: true
    }
}
const getMainTableConfig: any = (functions: any) => {
    const {indexFunction, getFunction} = functions;
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    return tableConfig;
}
export default getMainTableConfig;